import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { FC } from 'react';
import { ConfigurationEnum } from '@/types/metadata/metadata';
import { isNumber } from '@/util/typeGuards';
import { enumUtil } from '@/util/validation/enum';
import ParamRenderer, { ParamProps } from './ParamRenderer';

const ParamEnum: FC<ParamProps> = (props) => {
  const configuration = props.configuration as ConfigurationEnum;

  const values = enumUtil().getValue(configuration, props.initialValue);

  const handleChange = (event: SelectChangeEvent<string>) => {
    const index = Number.parseInt(event.target.value);
    triggerChange(index);
  };

  const processSections = (
    initialValue: Record<string, any>,
    sections?: ConfigurationEnum[][],
    result: [string, unknown][] = []
  ) => {
    sections?.forEach((sectionArray) => {
      sectionArray.forEach((section) => {
        if (initialValue[section.value]) {
          result.push([section.value, section.options?.find((option) => option.default)?.value || undefined]);
        } else if (section.sections) {
          processSections(initialValue, section.sections, result);
        }
      });
    });
    return result;
  };

  const triggerChange = (index: number) => {
    const optionValue = configuration.options[index];
    const result = [
      [configuration.value, optionValue.value],
      ...processSections(props.initialValue, configuration.sections, [])
    ] as [string, unknown][];

    props.onChange(...result);
  };

  const chosenSection =
    configuration.sections && isNumber(values.index) ? configuration.sections[values.index] : undefined;

  return (
    <FormControl
      size='small'
      fullWidth
      sx={{ display: 'flex', gap: 1 }}
      required={props.configuration.required}
      error={!!props.errors?.length}
    >
      <InputLabel>{configuration.label}</InputLabel>
      <Select
        value={isNumber(values.index) ? values.index.toString() : ''}
        label={configuration.label}
        onChange={handleChange}
        required={props.configuration.required}
        error={!!props.errors?.length}
      >
        {configuration.options.map((option, index) => (
          <MenuItem key={`${option.value}.${index}`} value={index}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {chosenSection?.map((configuration, index) => {
        const initialValuePart =
          configuration.type === 'enum' ? values.allData : values.allData && values.allData[configuration.value];
        return (
          <ParamRenderer
            key={`${configuration.value}.${index}`}
            nodeId={props.nodeId}
            parentId={props.parentId}
            configuration={configuration}
            initialValue={initialValuePart}
            onChange={props.onChange}
          />
        );
      })}
    </FormControl>
  );
};

export default ParamEnum;
